import { Mistake } from "../resume-analyse-types";

const removeSpellingMistakes = (text: string, spellingMistakes: Mistake[]) => {
  return spellingMistakes.filter((mistake) => {
    const regex = new RegExp(`\\b${mistake.incorrect}\\b`, "i");
    return regex.test(text);
  });
};

export { removeSpellingMistakes };
